<template>
  <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="600">
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="blue" class="darken-4" dark>Detalles del Evento significativo</v-toolbar>
        <v-card-text>
          <v-container class="mt-1" v-if="!loading">
            <v-row no-gutters>
              <v-col sm="2" class="mb-2"> <b>Codigo:</b> </v-col>
              <v-col sm="10"> {{ evento.codigo }} </v-col>

              <v-col sm="2" class="mb-2"> <b>Descripcion:</b> </v-col>
              <v-col sm="10"> {{ evento.descripcion }} </v-col>

              <v-col sm="2" class="mb-2"> <b>Codigo Recepcion:</b> </v-col>
              <v-col sm="10"> {{ evento.codigoRecepcion }} </v-col>

              <v-col sm="2" class="mb-2"> <b>Cufd Id:</b> </v-col>
              <v-col sm="10"> {{ evento.cufdId }} </v-col>

              <v-col sm="2" class="mb-2"> <b>Cufd Evento:</b> </v-col>
              <v-col sm="10"> {{ evento.cufdEvento }} </v-col>

              <v-col sm="2" class="mb-2"> <b>Fecha inicio:</b> </v-col>
              <v-col sm="10"> {{ evento.fecha_inicio }} </v-col>

              <v-col sm="2" class="mb-2"> <b>Fecha fin:</b> </v-col>
              <v-col sm="10"> {{ evento.fecha_fin }} </v-col>

              <v-col sm="2" class="mb-2"> <b>Sucursal:</b> </v-col>
              <v-col sm="10"> {{ evento.sucursal.municipio }} </v-col>

              <v-col sm="2" class="mb-2"> <b>Punto Venta:</b> </v-col>
              <v-col sm="10"> {{ evento.puntoVenta.nombre }} </v-col>
            </v-row>
          </v-container>

          <v-progress-linear class="mt-4" indeterminate v-if="loading" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="dialog.value = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        msg: '',
        evento: {
          id: 3,
          codigo: '1',
          descripcion: 'CORTE DEL SERVICIO DE INTERNET',
          codigoRecepcion: '1',
          puntoVentaId: 4,
          cufdId: 60,
          cufdEvento: 'QcKhQsK/MWFFQQ==Q0VFOTg4N0Y2NzY=QlVBcDhGQkdXVUFBNzFGMzkxRTNGODM0',
          fecha_inicio: '2022-05-31T20:36:48.557',
          fecha_fin: '2022-05-31T20:34:10.553',
          sucursalId: 1,
          cuisId: 0,
          sucursal: {
            id: 1,
            codigoSucursal: 0,
            municipio: 'tarija',
            nombre: 'CASA MATRIZ',
            telefono: '4-58545',
            estado: 1,
            direccion: 'CALLE LA MADRID NRO. 741, ZONA/BARRIO EL MOLINO',
            descripcion: '',
          },
          puntoVenta: {
            id: 4,
            nombre: 'principal',
            descripcion: ' ',
            sucursalId: 1,
            tipoPuntoVenta: 0,
            codigoPuntoVenta: 0,
            estado: 1,
          },
          estado: 1,
          links: [
            {
              rel: 'all-sucursales',
              href: 'http://localhost:8080/facturacion/eventosignificativo',
            },
          ],
          xapikey: null,
        },
      };
    },
    components: {},
    methods: {
      openmodal(item, xapikey) {
        this.xapikey = xapikey;
        this.msg = '';
        this.dialog = true;
        window.console.log(item);
        this.geteventosig(item.id);
      },
      geteventosig(idevento) {
        this.loading = true;
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/eventosignificativo/${idevento}`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.xapikey ? this.xapikey : this.$store.getters.getApiKey,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            vue.evento = data;
            window.console.log('geteventosig:', data);
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
    },
  };
</script>
